import { useMemo } from 'react'
import { translations } from '../../../configs/translations'
import { useStore } from '../../../store/store'
import { FineTuningPerformaceCategory } from '../FineTuning.types'
import { FineTuningCaracteristicsService } from './FineTuningCaracteristics.service'
import './FineTuningCharacteristics.css'
import { PerformaceValues } from './FineTuningCharacteristics.types'

export const FineTuningCharacteristics = ({
	profile,
	performanceCategories,
	fineTuningSettingsRef,
	performanceService
}: {
	profile: string
	performanceCategories: FineTuningPerformaceCategory[],
	fineTuningSettingsRef: number
	performanceService: FineTuningCaracteristicsService | null
}) => {
	const language = useStore(state => state.language)
	const t = translations[language]

	const performanceValues = useMemo(() => {
		if (!performanceService) return null
		return performanceService.calculatePerformaceValues(profile)
	}, [fineTuningSettingsRef, performanceService])

	return (
		<div className={`fine-tuning-characteristics ${profile}`}>

			<div className={`fine-tuning-characteristics-header ${profile}`}>
				<p className='fine-tuning-characteristics-header-text'>{t.characteristics}</p>
			</div>

			<div className='fine-tuning-characteristics-body'>

				{
					performanceCategories.map((category, index) => (
						<div key={index} className='fine-tuning-characteristics-body-item'>

							<div className='fine-tuning-characteristics-body-item-header'>
								<p className='fine-tuning-characteristics-body-item-header-text'>{t[category.translation as keyof typeof t]}</p>
							</div>

							{
								category.performanceList.map((performance, index) => {
									return (
										<div key={index} className='fine-tuning-characteristics-body-item-field'>
											<p className='fine-tuning-characteristics-body-item-field-name'>{t[performance.translation as keyof typeof t]}</p>
											<div className='fine-tuning-characteristics-body-item-field-value'>
												<p className='fine-tuning-characteristics-body-item-field-value-p'>
													{(performanceValues?.[performance.name as keyof PerformaceValues] as number ?? 0)}
												</p>
												<p className='fine-tuning-characteristics-body-item-field-value-symbol'>
													{t[performance.symbol as keyof typeof t]}
												</p>
											</div>
										</div>
									)
								})
							}
						</div>)
					)}

			</div>

		</div>

	)
}